import { numberShorthand } from '@benzinga/utils';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';

import styled from '@benzinga/themetron';
import { IRowNode, ValueFormatterParams } from 'ag-grid-community';
import React from 'react';
import { NO_VALUE } from '../../Ticker';
import { CustomCellRendererProps } from 'ag-grid-react';
import { isNil } from '@benzinga/utils';

const ChangePercentRenderer: React.FC<CustomCellRendererProps> = props => {
  const val = props.value;
  const valFormat = props.valueFormatted;
  if (isNil(val)) {
    return <Neutral>{NO_VALUE}</Neutral>;
  } else if (val === 0) {
    return <Neutral>{valFormat}</Neutral>;
  } else if (val > 0) {
    return <Positive>{valFormat}</Positive>;
  } else {
    return <Negative>{valFormat}</Negative>;
  }
};

const Neutral = styled.div`
  padding: 0 6px;
`;

const Positive = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.positive} !important;
  fill: ${({ theme }) => theme.colors.statistic.positive} !important;
`;

const Negative = styled(Neutral)`
  color: ${({ theme }) => theme.colors.statistic.negative} !important;
  fill: ${({ theme }) => theme.colors.statistic.negative} !important;
`;

export const ChangeShortenedNumberColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellRenderer: ChangePercentRenderer,
  cellStyle: { textAlign: 'right' },

  // renderer handles
  comparator: (_valueA: number, _valueB: number, nodeA: IRowNode, nodeB: IRowNode) =>
    nodeA.data[nodeA.id ?? ''] - nodeB.data[nodeB.id ?? ''],

  filter: 'agNumberColumnFilter',
  valueFormatter: (data: ValueFormatterParams) => {
    const num = numberShorthand(data.value);
    return num && num !== '' ? num : NO_VALUE;
  },
  ...colDef,
  ...absColDef(colDef),
});
